<template>
    <section id="otherSkill" class="other-skill-card card mb-3">
        <form
            v-if="otherSkill"
            class="card-body"
            v-click-outside="onClickOutside"
            @click="focusBlock"
        >
            <div class="card-heading">
                <h5 class="card-name" v-if="!isCaTa">
                    {{ $t('lib_skills') }}
                </h5>
                <h5 class="card-name" v-else>
                    {{ $t('lib_step_motivation_strenghts') }}
                </h5>
            </div>
            <hr />

            <div
                v-if="applicationTypeIsTrainee"
                class="form-group"
                :class="{
                    'required-group': isFieldRequired('technicalSkillsComment'),
                }"
            >
                <label for="technicalSkillsComment" class="form-label">
                    {{ $t('skill_technical') }}
                    <span
                        class="skills-icon"
                        tooltip-size="xl"
                        v-tooltip.top.hover.focus="
                            $t('popup_technical_skills_cor')
                        "
                    >
                        <font-awesome-icon icon="far fa-question-circle"/>
                    </span>
                </label>

                <textarea
                    id="technicalSkillsComment"
                    type="text"
                    v-model="otherSkill.technicalSkillsComment"
                    class="form-control"
                    maxlength="600"
                    :class="{
                        'is-invalid': errorMessage(
                            'technicalSkillsComment',
                            block.name
                        ),
                    }"
                />
                <p class="textarea-character-length">
                    {{
                        otherSkill.technicalSkillsComment
                            ? otherSkill.technicalSkillsComment.length
                            : '0'
                    }}/600
                </p>
                <div
                    v-if="errorMessage('technicalSkillsComment', block.name)"
                    class="invalid-feedback"
                >
                    {{ $t(errorMessage('technicalSkillsComment', block.name)) }}
                </div>
            </div>
            <div
                v-if="applicationTypeIsTrainee"
                class="form-group"
                :class="{
                    'required-group': isFieldRequired('socialSkillsComment'),
                }"
            >
                <label for="socialSkillsComment" class="form-label">
                    {{ $t('skill_social') }}
                    <span
                        class="skills-icon"
                        v-tooltip.top.hover.focus="
                            $t('popup_social_skills_cor')
                        "
                    >
                        <font-awesome-icon icon="far fa-question-circle"/>
                    </span>
                </label>
                <textarea
                    id="socialSkillsComment"
                    type="text"
                    v-model="otherSkill.socialSkillsComment"
                    class="form-control"
                    maxlength="600"
                    :class="{
                        'is-invalid': errorMessage(
                            'socialSkillsComment',
                            block.name
                        ),
                    }"
                />
                <p class="textarea-character-length">
                    {{
                        otherSkill.socialSkillsComment
                            ? otherSkill.socialSkillsComment.length
                            : '0'
                    }}/600
                </p>
                <div
                    v-if="errorMessage('socialSkillsComment', block.name)"
                    class="invalid-feedback"
                >
                    {{ $t(errorMessage('socialSkillsComment', block.name)) }}
                </div>
            </div>
            <div
                v-if="applicationTypeIsTrainee"
                class="form-group"
                :class="{
                    'required-group': isFieldRequired('computerSkillsComment'),
                }"
            >
                <label for="computerSkillsComment" class="form-label">
                    {{ $t('skill_computer') }}
                    <span
                        class="skills-icon"
                        v-tooltip.top.hover.focus="
                            $t('popup_computer_skills_cor')
                        "
                    >
                        <font-awesome-icon icon="far fa-question-circle"/>
                    </span>
                </label>
                <textarea
                    id="computerSkillsComment"
                    type="text"
                    v-model="otherSkill.computerSkillsComment"
                    class="form-control"
                    maxlength="600"
                    :class="{
                        'is-invalid': errorMessage(
                            'computerSkillsComment',
                            block.name
                        ),
                    }"
                />
                <p class="textarea-character-length">
                    {{
                        otherSkill.computerSkillsComment
                            ? otherSkill.computerSkillsComment.length
                            : '0'
                    }}/600
                </p>
                <div
                    v-if="errorMessage('computerSkillsComment', block.name)"
                    class="invalid-feedback"
                >
                    {{ $t(errorMessage('computerSkillsComment', block.name)) }}
                </div>
            </div>
            <div
                v-if="applicationTypeIsTrainee"
                class="form-group"
                :class="{
                    'required-group': isFieldRequired(
                        'organizationalSkillsComment'
                    ),
                }"
            >
                <label for="organizationalSkillsComment" class="form-label">
                    {{ $t('skill_organisation') }}
                    <span
                        class="skills-icon"
                        v-tooltip.top.hover.focus="
                            $t('popup_organizational_skills_cor')
                        "
                    >
                        <font-awesome-icon icon="far fa-question-circle"/>
                    </span>
                </label>
                <textarea
                    id="organizationalSkillsComment"
                    type="text"
                    v-model="otherSkill.organizationalSkillsComment"
                    class="form-control"
                    maxlength="600"
                    :class="{
                        'is-invalid': errorMessage(
                            'organizationalSkillsComment',
                            block.name
                        ),
                    }"
                />
                <p class="textarea-character-length">
                    {{
                        otherSkill.organizationalSkillsComment
                            ? otherSkill.organizationalSkillsComment.length
                            : '0'
                    }}/600
                </p>
                <div
                    v-if="
                        errorMessage('organizationalSkillsComment', block.name)
                    "
                    class="invalid-feedback"
                >
                    {{
                        $t(
                            errorMessage(
                                'organizationalSkillsComment',
                                block.name
                            )
                        )
                    }}
                </div>
            </div>
            <div
                v-if="isCaTa"
                class="form-group"
                :class="{
                    'required-group': isFieldRequired(
                        'experienceComment'
                    ),
                }"
            >
                <label for="experienceComment" class="form-label">
                    {{ $t('skill_cata_experience') }}
                </label>
                <textarea
                    id="experienceComment"
                    type="text"
                    v-model="otherSkill.experienceComment"
                    class="form-control"
                    maxlength="1000"
                    :class="{
                        'is-invalid': errorMessage(
                            'experienceComment',
                            block.name
                        ),
                    }"
                />
                <p class="textarea-character-length">
                    {{
                        otherSkill.experienceComment
                            ? otherSkill.experienceComment.length
                            : '0'
                    }}/1000
                </p>
                <div
                    v-if="
                        errorMessage('experienceComment', block.name)
                    "
                    class="invalid-feedback"
                >
                    {{
                        $t(
                            errorMessage(
                                'experienceComment',
                                block.name
                            )
                        )
                    }}
                </div>
            </div>
            <div
                v-if="isCaTa"
                class="form-group mb-3"
                :class="{
                    'required-group': isFieldRequired(
                        'skillsComment'
                    ),
                }"
            >
                <label for="skillsComment" class="form-label">
                    {{ $t('skill_cata_skills') }}
                </label>
                <textarea
                    id="skillsComment"
                    type="text"
                    v-model="otherSkill.skillsComment"
                    class="form-control"
                    maxlength="1000"
                    :class="{
                        'is-invalid': errorMessage(
                            'skillsComment',
                            block.name
                        ),
                    }"
                />
                <p class="textarea-character-length">
                    {{
                        otherSkill.skillsComment
                            ? otherSkill.skillsComment.length
                            : '0'
                    }}/1000
                </p>
                <div
                    v-if="
                        errorMessage('skillsComment', block.name)
                    "
                    class="invalid-feedback"
                >
                    {{
                        $t(
                            errorMessage(
                                'skillsComment',
                                block.name
                            )
                        )
                    }}
                </div>
            </div>
            <div
                v-if="isCaTa"
                class="form-group"
                :class="{
                    'required-group': isFieldRequired(
                        'motivationComment'
                    ),
                }"
            >
                <label for="motivationComment" class="form-label">
                    {{ $t('skill_cata_motivation') }}
                </label>
                <textarea
                    id="motivationComment"
                    type="text"
                    v-model="otherSkill.motivationComment"
                    class="form-control"
                    maxlength="1000"
                    :class="{
                        'is-invalid': errorMessage(
                            'motivationComment',
                            block.name
                        ),
                    }"
                />
                <p class="textarea-character-length">
                    {{
                        otherSkill.motivationComment
                            ? otherSkill.motivationComment.length
                            : '0'
                    }}/1000
                </p>
                <div
                    v-if="
                        errorMessage('motivationComment', block.name)
                    "
                    class="invalid-feedback"
                >
                    {{
                        $t(
                            errorMessage(
                                'motivationComment',
                                block.name
                            )
                        )
                    }}
                </div>
            </div>
            <div
                v-if="!isCaTa"
                class="form-group mb-3"
                :class="{ 'required-group': isFieldRequired('comment') }"
            >
                <label for="comment" class="form-label">
                    {{ $t('skill_other') }}
                    <span
                        class="skills-icon"
                        v-tooltip.top.hover.focus="$t('popup_other_skills_cor')"
                    >
                        <font-awesome-icon icon="far fa-question-circle"/>
                    </span>
                </label>
                <textarea
                    id="comment"
                    type="text"
                    v-model="otherSkill.comment"
                    class="form-control"
                    maxlength="600"
                    :class="{
                        'is-invalid': errorMessage('comment', block.name),
                    }"
                />
                <p class="textarea-character-length">
                    {{
                        otherSkill.comment ? otherSkill.comment.length : '0'
                    }}/600
                </p>
                <div
                    v-if="errorMessage('comment', block.name)"
                    class="invalid-feedback"
                >
                    {{ $t(errorMessage('comment', block.name)) }}
                </div>
            </div>
            <div class="card-footer d-flex justify-content-end mt-3" v-if="formWasChanged">
                <div class="card-actions">
                    <button
                        type="button"
                        class="card-action save-action btn btn-text me-2"
                        @click="validate()"
                        :disabled="appLoading"
                    >
                        <font-awesome-icon icon="far fa-save" class="fs-5 btn-icon"/>
                        <span class="btn-label">
                            {{ $t('btn_save') }}
                        </span>
                    </button>
                    <button
                        type="button"
                        class="card-action undo-changes-action btn btn-text"
                        @click="undoChanges()"
                        :disabled="appLoading"
                    >
                        <font-awesome-icon icon="fas fa-undo"/>
                        <span class="btn-label">
                            {{ $t('btn_cancel') }}
                        </span>
                    </button>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
export default {
    name: 'OtherSkill',
    components: {
        // Chips,
    },
    props: {
        block: {
            type: Object,
            required: true,
        },
        applicationId: {
            type: String,
            required: true,
        },
        applicationType: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            otherSkill: null,
            listenToClickOutside: false,
            formWasChanged: false,
        };
    },
    computed: {
        ...mapGetters([
            'blockErrorMessage',
            'errorMessage',
            'isFieldRequired',
            'otherSkillData',
            'applicationTypeIsTrainee',
            'appLoading',
            'applicationTypeIsCa',
            'applicationTypeIsTa'
        ]),
        isCaTa(){
            return this.applicationTypeIsCa || this.applicationTypeIsTa
        }
        // formWasChanged() {
        //     if(JSON.stringify(this.otherSkill) === JSON.stringify(this.otherSkillData)) {
        //         // this.clearBlockErrors(this.block.name);
        //     }
        //     return (
        //         JSON.stringify(this.otherSkill) !==
        //         JSON.stringify(this.otherSkillData)
        //     );
        // },
    },
    methods: {
        ...mapActions([
            'validateBlock',
            'updateBlock',
            'clearBlockErrors',
            'focusOnBlock',
        ]),
        validate() {
            this.clearBlockErrors(this.block.name);
            this.validateBlock({
                blockData: this.otherSkill,
                blockName: this.block.name,
            }).then(
                () => {
                    this.updateBlock({
                        blockName: this.block.name,
                        application: {
                            applicationId: this.applicationId,
                            applicationType: this.applicationType,
                            applicationBlocks: {
                                [this.block.name]: this.otherSkill,
                            },
                        },
                    }).then(
                        () => {
                            // success
                            this.listenToClickOutside = false;
                            this.$toast.add({
                                severity: 'success',
                                detail: this.$t('mess_save_success'),
                                life: 3000,
                            });
                            this.loadData();
                            this.$emit('checkErrorForOtherBlocks');
                        },
                        () => {
                            // error
                            this.listenToClickOutside = false;
                            this.$toast.add({
                                severity: 'error',
                                detail: this.$t('mess_save_failed'),
                                life: 3000,
                            });
                        }
                    );
                },
                () => {
                    // error
                    this.listenToClickOutside = false;
                    this.$toast.add({
                        severity: 'error',
                        detail: this.$t('mess_save_failed'),
                        life: 3000,
                    });
                }
            );
        },
        onClickOutside() {
            if (
                this.listenToClickOutside &&
                this.formWasChanged &&
                !this.appLoading
            ) {
                this.clearBlockErrors(this.block.name);
                this.validate();
            }
            this.focusOnBlock(null);
        },
        undoChanges() {
            this.loadData();
            this.clearBlockErrors(this.block.name);
        },
        loadData() {
            this.otherSkill = _.cloneDeep(this.otherSkillData);
        },
        focusBlock() {
            this.listenToClickOutside = true;
            this.focusOnBlock({
                name: 'otherSkill',
                label: this.$t('lib_skills'),
            });
        }
    },
    mounted() {
        this.loadData();
    },
    watch: {
        // whenever skill object changes, this function will run and this way we will now if the form data was changed so we can save changes;
        otherSkill: {
            handler(newData, oldData) {
                const storeData = {
                    ...this.otherSkillData,
                };
                this.formWasChanged =
                    JSON.stringify(newData) !== JSON.stringify(storeData);

                if (!this.formWasChanged && oldData) {
                    // checking for oldData to prevent clearing the errors on firstload;
                    this.clearBlockErrors(this.block.name);
                }
            },
            deep: true,
        },
    },
};
</script>
